module.exports = __webpack_public_path__ + "static/kroger-intro-img-02-a6c2ed9056fac83399594a23b4e8146d.png";